import api from "@utils/api";

export const getEmployeesRegisters = () => api.get("/employee_register/");

export const getEmployeeById = (id) => api.get(`/employee_register/${id}`);
export const getEmployeesRegistersByPlaceId = (id) =>
  api.get(`/employee_register/place/${id}`);
export const createEmployeeRegister = (employeeRegister) =>
  api.post("/employee_register", employeeRegister);

export const updateEmployee = (id, employee) =>
  api.put(`/employee_register/${id}`, employee);

export const deleteEmployeeRegister = (id) =>
  api.delete(`/employee_register/${id}`);

export const getEmployeePaginated = (idOrg, page, per_page, desde = null, hasta = null) => {
  // La vista "todas las sedes" ahora respeta el rango de fecha (igual que por sede).
  // Sin acotar por fecha, el backend barría toda la historia de la org -> gateway timeout.
  let url = `employee_register/organizacion/${idOrg}?page=${page}&per_page=${per_page}`;
  if (desde) url += `&desde=${desde}`;
  if (hasta) url += `&hasta=${hasta}`;
  return api.get(url);
};

export const getEmployeeByPlaceIdPaginated = (id, page, per_page) =>
  api.get(`/employee_register/place/${id}?page=${page}&per_page=${per_page}`);

export const getFilterEmployeeByDate = (
  placeId,
  startDate,
  endDate,
  page,
  perPage
) =>
  api.get(
    `/employee_register/filter/${placeId}?start_date=${startDate}&end_date=${endDate}&page=${page}&per_page=${perPage}`
  );

export const getExcelAllEmployeesRegisters = async (idOrganizacion, startDate, endDate, placeId = null) => {
  try {
    let url = `/employee_register/export/excel?desde=${startDate}&hasta=${endDate}&id_organizacion=${idOrganizacion}`;
    if (placeId) url += `&place_id=${placeId}`;
    const response = await api.get(url);
    return response.data;
  } catch (error) {
    throw new Error(`Error al obtener el archivo Excel: ${error.message}`);
  }
};

export const getExcelAllEmployeesRegistersS3 = async (idOrganizacion, startDate, endDate, placeId = null) => {
  try {
    let url = `/employee_register/export/excel_s3?desde=${startDate}&hasta=${endDate}&id_organizacion=${idOrganizacion}`;
    if (placeId) url += `&place_id=${placeId}`;
    const response = await api.get(url);
    return response.data;
  } catch (error) {
    throw new Error(`Error al obtener el archivo Excel: ${error.message}`);
  }
};

export const getEmployeeByCedulaPaginated = async(
  cedula,
  page,
  per_page,
) => {
  try {
    const response = await api.get(`/employee_register/cedula/${cedula}?page=${page}&per_page=${per_page}`);
    return response;
  } catch (error) {
    throw new Error(`Error al obtener el  empleado por cedula: ${error.message}`);
  }
};

// Nuevo servicio para traer el último evento
export const getLastEmployeeEvent = async ({ organizacionId = null, placeId = null }) => {
  const params = new URLSearchParams();
  if (organizacionId) params.append("organizacion_id", organizacionId);
  if (placeId) params.append("place_id", placeId);

  return api.get(`/employee_register/last?${params.toString()}`);
};

// Trae las estadísticas de tráfico de empleados (grupo por día / mes)
export const getEmployeeTraffic = async ({
  organizacionId = null,
  placeId = null,
  startDate,
  endDate,
  groupBy = "day",
}) => {
  const params = new URLSearchParams();
  params.append("start_date", startDate);      // ISO 8601
  params.append("end_date", endDate);          // ISO 8601
  params.append("group_by", groupBy);          // "day" | "month"
  if (organizacionId) params.append("organizacion_id", organizacionId);
  if (placeId) params.append("place_id", placeId);

  return api.get(`/employee_register/traffic?${params.toString()}`);
};

export const getEmployeeDetailedHours = async ({
  organizacionId,
  placeId = null,
  startDate,
  endDate,
  page = 1,
  perPage = 10,
  groupBy = "day",
}) => {
  const params = new URLSearchParams();
  params.append("organizacion_id", organizacionId);
  params.append("start_date", startDate);
  params.append("end_date", endDate);
  params.append("page", page);
  params.append("per_page", perPage);
  params.append("group_by", groupBy);
  if (placeId) params.append("place_id", placeId);

  return api.get(`/employee_register/report/hours?${params.toString()}`);
};

export const getEmployeeDetailedHoursExcelS3 = async ({
  organizacionId,
  placeId = null,
  startDate,
  endDate,
  groupBy = "day",
}) => {
  const params = new URLSearchParams();
  params.append("organizacion_id", organizacionId);
  params.append("start_date", startDate);
  params.append("end_date", endDate);
  params.append("group_by", groupBy);
  if (placeId) params.append("place_id", placeId);

  try {
    const response = await api.get(`/employee_register/report/hours/export_excel_s3?${params.toString()}`);
    return response.data.url;
  } catch (error) {
    throw new Error("Error al generar el Excel");
  }
};